import { isNull, isUndefined } from 'lodash-es';

export const isNullOrUnDef = (value: any): boolean => {
  return isUndefined(value) || isNull(value);
};
